module.exports = __webpack_public_path__ + "img/antes_despues_12.1ce79b89.png";